import React, { useMemo } from "react";
import { RichText, TwoColumns, WideImage, Caption, Video, ImageText, TextImage, MiniCta } from "../components";
import NewsCard from "../../global/newsCard";
import ContactFormEmail from "../../global/contactFormEmail";
import ContactFormChronic from "../../global/contactFormChronic";

export default function BlogContent({ data: components, nextPost }) {
  const contactFormEmail = useMemo(
    () => ({
      formTitle: "Need more information",
      fields: ["name", "email", "phone"],
      emailTo: "contact@speedoc.com",
      emailFrom: "support@speedoc.com",
      subject: "Speedoc for Business Request",
      parent: "business",
      buttonText: "Submit a Request"
    }),
    []
  );

  const getReactComponent = component => {
    switch (component.name) {
      case "NewsCard":
        return nextPost && <NewsCard content={nextPost} key={component.id} />;
      case "ContactForm":
        return <ContactFormEmail key={component.id} content={contactFormEmail} />;
      default:
        return null;
    }
  };

  const renderComponent = (component, i) => {
    switch (component.__typename) {
      case "ComponentBlogTextBlock":
        return <RichText data={component.richText} key={i} />;
      case "ComponentBlogTwoColumns":
        return <TwoColumns dataLeft={component.left} dataRight={component.right} key={i} />;
      case "ComponentBlogWideImage":
        return (
          <WideImage
            key={i}
            src={component.imageWide?.formats?.medium?.url}
            alt={component.imageWide?.alternativeText}
          />
        );
      case "ComponentBlogCaption":
        return <Caption data={component.caption} key={i} />;
      case "ComponentBlogVideo":
        return <Video data={component} key={i} />;
      case "ComponentBlogReactComponent":
        return getReactComponent(component);
      case "ComponentBlogImageText":
        return <ImageText data={component} key={i} />;
      case "ComponentBlogTextImage":
        return <TextImage data={component} key={i} />;
      case "ComponentPageContactForm":
        return <ContactFormChronic content={component} key={i} />;
      case "ComponentBlogMiniCta":
        return <MiniCta content={component} key={i} />;
      default:
        return null;
    }
  };
  return <div className="blogContent">{components.map((c, i) => renderComponent(c, i))}</div>;
}
